import {chainWalk, deepCopyObject} from "../../../util/Util";

export const updateConfigurationsInZancaSortAssetObject = (asset, configurations, alias) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.alias = chainWalk(() => alias.toString(), "");
    updatedAsset.assetDetails.assetAttributes.testConfig =
        chainWalk(() => JSON.stringify(configurations.testConfig), "[]")
    updatedAsset.assetDetails.assetAttributes.locationConfig =
        chainWalk(() => JSON.stringify(configurations.locationConfig), "[]")
    return updatedAsset;
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/datamodel/ZancaSortAssetModelResource.js